function warehouseController() {}

export default warehouseController;
